<div id="info-alert" style="min-height: 1em">

  <alert *ngIf="mostrar" type="{{tipo}}" dismissible={{dismiss}} dismissOnTimeout={{timeout}} (onClosed)="alertFechado($event)">
    <i [ngClass]="prefixo" aria-hidden="true"> </i>
    <span>{{mensagem}}</span>
  </alert>
</div>
